import { z } from 'zod';

import { clientSchema } from 'entities/Client';
import { employeeSchema } from 'entities/Employee';
import { leadStatus } from 'entities/Lead';

export const clientWithLeadSchema = z
  .intersection(
    clientSchema,
    z.object({
      last_leads: z.array(
        z.object({
          id: z.number(),
          status: leadStatus,
          user: employeeSchema.nullable(),
          project: z
            .object({
              id: z.number(),
              name: z.string(),
            })
            .nullable(),
          place_type: z
            .object({
              id: z.number(),
              name: z.string(),
            })
            .nullable(),
          comment: z.string().nullable(),
          fixed_until: z.string().pipe(z.coerce.date()).nullable(),
        }),
      ),
    }),
  )
  .transform(({ last_leads, ...client }) => {
    const uniqueLeadsById = Array.from(new Map(last_leads.map((item) => [item.id, item])).values());

    return {
      ...client,
      leads: uniqueLeadsById.map((lead) => ({
        id: lead.id,
        status: lead.status,
        user: lead.user,
        project: lead.project,
        placeType: lead.place_type,
        comment: lead.comment,
        fixedUntil: lead.fixed_until,
      })),
    };
  });

export type ClientWithLeadsEntityApi = z.input<typeof clientWithLeadSchema>;

export type ClientWithLeadsEntity = z.infer<typeof clientWithLeadSchema>;

export type ClientLeadEntity = ClientWithLeadsEntity['leads'][number];
